import * as React from 'react';

import {Button} from '../../../button/button';
import {Dialog} from '../../../dialog/dialog';

import styles from './message-bubble.module.css';

type PrimaryButtonInfo = {
    text: string;
    onClick: () => void;
};

export type SecondaryButtonInfo =
    | {
          text: string;
          confirmationQuestion: string;
          confirmationPrimaryText: string;
          confirmationSecondaryText: string;
          onClick: () => void;
      }
    | null
    | undefined;

type Props = {
    preventResend: boolean;
    primaryButtonInfo: PrimaryButtonInfo;
    secondaryButtonInfo?: SecondaryButtonInfo;
};

export function ActionButtons(props: Props) {
    const [isConfirming, setIsConfirming] = React.useState(false);
    const deleteRef = React.useRef(null);

    return (
        <>
            <div className={styles.buttons}>
                {props.secondaryButtonInfo && (
                    <>
                        <Button
                            variant='text-danger'
                            onClick={() => setIsConfirming(true)}
                            getButtonRef={deleteRef}
                            noPadding={true}
                        >
                            {props.secondaryButtonInfo.text}
                        </Button>
                        ·
                    </>
                )}
                {props.preventResend ? undefined : (
                    <Button
                        variant='text-primary'
                        onClick={props.primaryButtonInfo.onClick}
                        noPadding={true}
                    >
                        {props.primaryButtonInfo.text}
                    </Button>
                )}
            </div>
            {isConfirming && props.secondaryButtonInfo && (
                <Dialog
                    anchor={deleteRef.current}
                    question={props.secondaryButtonInfo.confirmationQuestion}
                    primaryText={props.secondaryButtonInfo.confirmationPrimaryText}
                    secondaryText={props.secondaryButtonInfo.confirmationSecondaryText}
                    onPrimary={() => {
                        setIsConfirming(false);
                        // @ts-expect-error
                        props.secondaryButtonInfo.onClick();
                    }}
                    onSecondary={() => {
                        setIsConfirming(false);
                    }}
                    isWarning={true}
                />
            )}
        </>
    );
}
